import { Helmet } from 'react-helmet-async';

export default function SEOHead({ seo }) {
  if (!seo) return null;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo.canonical && <link rel="canonical" href={seo.canonical} />}

      {seo.og && (
        <>
          <meta property="og:title" content={seo.og.title} />
          <meta property="og:description" content={seo.og.description} />
          <meta property="og:type" content={seo.og.type} />
          <meta property="og:url" content={seo.og.url} />
          {seo.og.image && <meta property="og:image" content={seo.og.image} />}
        </>
      )}

      {seo.schema && (
        <script type="application/ld+json">
          {JSON.stringify(seo.schema)}
        </script>
      )}
    </Helmet>
  );
}
